import * as yup from "yup";
import { isEmpty, isEmptyObject } from "../utils/validators";

const getContactSchema = (t, customValidators) => {
  return yup.object().shape({
    name: yup
      .string()
      .required(t("validators.notEmpty"))
      .min(0, t("validators.minLength", { value: 0 }))
      .max(50, t("validators.maxLength", { value: 50 })),
    email: yup
      .string()
      .required(t("validators.notEmpty"))
      .email(t("validators.email"))
      .min(0, t("validators.minLength", { value: 0 }))
      .max(45, t("validators.maxLength", { value: 45 })),
    email2: yup
      .string()
      .required(t("validators.notEmpty"))
      .email(t("validators.email"))
      .min(0, t("validators.minLength", { value: 0 }))
      .max(45, t("validators.maxLength", { value: 45 }))
      .oneOf([yup.ref("email"), null], t("validators.compareFields")),
    tlf: yup
      .string()
      .notRequired()
      .test("tlf-validator", t("validators.phone"), (value, context) => {
        if (!isEmptyObject(customValidators?.tlf)) {
          if (!isEmpty(value)) {
            const result = customValidators.tlf(value, context);
            return result;
          }
        }
        return true;
      }),
    reason: yup
      .object()
      .shape({
        value: yup.string(),
        label: yup.string(),
      })
      .required(t("validators.notEmpty"))
      .nonNullable(t("validators.notEmpty")),
    message: yup
      .string()
      .required(t("validators.notEmpty"))
      .min(0, t("validators.minLength", { value: 0 }))
      .max(800, t("validators.maxLength", { value: 800 })),
    consent: yup
      .bool()
      .required(t("validators.notEmpty"))
      .oneOf([true], t("validators.checkTrue")),
  });
};

export default getContactSchema;
